import { se } from "date-fns/locale";

export default {
    translations: { // Mesmo valor usado nas configurações (defaultNS)
      links_menu:{
        mapa: 'Painel Técnico',
        metagenomic: 'Metagenômica',
        ibp: 'Socioeconômico',
        climate: 'Climático',
        webbased: 'Web Based',
        mapa_resumido: 'Painel Estratégico',
      },
      sankey: {
        sem_dados: 'Sem dados disponíveis',
        col1tab1: 'Cidade Hub por Proporção de Caminho',
        col2tab1: 'Estado da Cidade Hub',
        col3tab1: 'Código IBGE da Cidade Hub',
        col4tab1: 'Proporção de Caminhos que Levam ao Hub',
        col1tab2: 'Cidade de Entrada',
        col2tab2: 'Código IBGE da Cidade de Entrada',
        col3tab2: 'Cidade Afetada',
        col4tab2: 'Unidade Federativa da Cidade Afetada',
        col5tab2: 'Código IBGE da Cidade Afetada',
        col6tab2: 'Proporção de Caminhos que Levam às Cidades Afetadas',
        col1tab3: 'Cidades Sugeridas para Detecção Precoce de Patógenos na Cidade Selecionada',
        col2tab3: 'Estado da Cidade Hub',
        col3tab3: 'Código IBGE da Cidade Hub',
        col4tab3: 'Proporção de Caminhos que Levam ao Hub',
      },
      dashboard: {
        //title: 'Monitoramento das Infecções Respiratórias Atenção Primária em Saúde (APS) no Brasil',
        //subtitle: 'Visão Geral dos Atendimentos por Infecções de Via Aérea Superior (Gripais)',
        nacional: 'Nacional',
        estadual: 'Estadual',
        municipal: 'Municipal',
        nacionais: 'Nacionais',
        estaduais: 'Estaduais',
        municipais: 'Municipais',
        baixissima_privacao: 'Baixíssima privação',
        baixa_privacao: 'Baixa privação',
        moderada_privacao: 'Privação moderada ',
        alta_privacao: 'Alta privação',
        altissima_privacao: 'Altíssima Privação',
        sim: 'Sim',
        nao: 'Não',
        titulo_ranking: 'Critérios de Ordenação dos Municípios',
        ranking: 'Ordenação',
        titulo_principal: 'Principal',
        titulo_acessorio: 'Acessório',
        mobilidade: 'Mobilidade',
        densidade: 'Densidade',
        /*ibp: 'IBP',*/
        dsei: 'DSEI',
        otc: 'PIP',
        aviso_otc: 'Aviso PIP',
        a: 'a',
        e: 'e',
        ano: 'Ano',
        num_sinais_ensamble: 'Número de Sinais Ensamble',
        title: 'Monitoramento dos Atendimentos por Provável Síndrome Gripal na Atenção Primária em Saúde (APS) no Brasil',
        subtitle: '',
        title_resumo: 'Painel Resumo',
        title_climate: 'Painel Climático',
        title_ibp: 'Atendimentos por Síndrome Gripal na APS em Contexto de Privação Socioeconômica',
        /*title_metagenomic: 'Painel Metagenômica',*/
        title_metagenomic: 'Locais Estratégicos para Coleta de Amostras Metagenômicas',
        title_webbased: 'Eventos de Interesse na Web',
        queda: 'Queda',
        estavel: 'Estável',
        alerta: 'Atenção',
        alta : 'Alta',
        data : 'Data',
        ultima_atualizacao : 'Última Atualização',
        buscar_uf: 'Filtrar UF',
        buscar_municipio: 'Filtrar Municipio',
        cidade : 'Município',
        estado : 'Estado',
        populacao: 'População',
        atencao: 'Atenção',
        aviso: 'Aviso',
        avisos: 'Avisos',
        aviso_mip: 'Aviso PIP',
        semana_ep: 'Semana Epidemiológica',
        semana: 'Semana',
        semanas: 'Semanas',
        tosse:'Tosse',
        febre:'Febre',
        dqi: 'DQI',
        ears: 'EARS',
        evi_simples: 'EVI',
        aps: 'Aviso APS',
        sinal_ears: 'Aviso EARS',
        sinal_evi: 'Aviso EVI',
        sinal_mmaing: 'Aviso MMAING',
        ambos: 'Ambos',
        sem_aviso: 'Sem Aviso',
        sem_aviso_mip: 'Sem Aviso PIP',
        apto: 'Apto',
        nao_apto: 'Não Apto',
        no_data: 'Sem Dados',
        aptos: 'Aptos',
        nao_aptos: 'Não Aptos',
        nao_validado: 'Não Validado',
        probabilidade_crescimento: 'Probabilidade de Crescimento',
        aviso_consecutivo: 'Aviso Consecutivo',
        aviso_vizinhos: 'N. de Municípios Fronteiriços em Aviso',
        avisos_consecutivos: 'N. de Semanas em Avisos Consecutivos',
        sem_informacao: 'Sem Informação',
        titulo_mapa_taxa_crescimento: 'Taxa de Crescimento de Provável Sindrome Gripal',
        titulo_mapa_atendimentos_excedentes : 'Provável Sindrome Gripal Excedente',
        titulo_mapa_evi: 'Sinal de Aviso',
        titulo_sinal_aps: 'APS',
        evi: 'EVI (Índice de Volatilidade Epidêmica)',
        legenda_mapa_taxa_crescimento: 'Taxa de Crescimento (%)',
        legenda_mapa_atendimentos_excedentes: 'Atendimentos Excedentes',
        perc_completude: 'Completude (%)',
        perc_tempestividade: 'Tempestividade (%)',
        faixa: 'Faixa',
        sinais_faixa: 'Sinais por Faixa',
        ibp:'Índice Brasileiro de Privação',
        origem: 'Origem',
        destino: 'Destino',
        retangulos:{
          titulo_excesso : 'Excesso de Provável Sindrome Gripal',
          mil: 'K',
          milhoes: 'M',
          bilhoes: 'G',
        },
        dados_climaticos: 'Dados Climáticos',
        graficos: {
          titulo_mm: 'Proporção de Provável Sindrome Gripal',
          legenda_mm: {
            1: 'Média Móvel',
            2: 'Proporção (Provável Sindrome Gripal / Total de atendimentos)'
          },
          titulo_variacao_mm : 'Taxa de Crescimento da Proporção de Provável Sindrome Gripal (Média Móvel)',
          titulo_atendimento_gripais : 'Provável Sindrome Gripal na APS',
          titulo_atendimento_totais : 'Total de Atendimentos na APS',
          titulo_excesso : 'Excesso de Provável Sindrome Gripal do Limite Esperado',
          titulo_limite : 'Limite Esperado de Provável Sindrome Gripal',
          titulo_precipitacao : 'Precipitação',
          titulo_humidade : 'Umidade',
          titulo_indice_calor :'Índice de Calor',
          titulo_temp2m :'Temperatura a 2 Metros',
          titulo_med_movel_precipitacao : 'Média Móvel Precipitação',
          titulo_med_movel_humidade : 'Média Móvel Umidade',
          titulo_med_movel_indice_calor :'Média Móvel Índice de Calor',
          titulo_med_movel_temp2m :'Média Móvel Temperatura a 2 Metros',
          titulo_tosse_febre: 'Tosse e Febre',
          titulo_prec: 'Precipitação Total Corrigida mm',
          titulo_temp: 'Temperatura Média Semanal ºC',
          titulo_um: 'Umidade Relativa do Ar %',
          titulo_canal_endemico: 'Canal Endêmico',
          titulo_limiar_endemico: 'Limiar Endêmico',
        },
        calendar: {
          titulo_meses: [
            "Janeiro",
            "Fevereiro",
            "Março",
            "Abril",
            "Maio",
            "Junho",
            "Julho",
            "Agosto",
            "Setembro",
            "Outubro",
            "Novembro",
            "Dezembro"
          ],
          titulo_dias: [
            "Dom",
            "Seg",
            "Ter",
            "Qua",
            "Qui",
            "Sex",
            "Sab",
          ],
          titulo_se_selected: 'Selecione uma Semana Epidemiológica:',
          titulo_timeline: 'Linha do Tempo',
          titulo_semanas: 'Semanas',
          titulo_datas: 'Datas',
          sigle_se: 'SE',
          titulo_visu: 'Modo de visualização',
        },
        table: {
          titulo: 'Consulta dos Indicadores nos Municípios',    
          titulo_rank: 'Lista das Cidades com Maior Potencial para Detecção Precoce de Patógenos',    
          titulo_rank_uf: 'Lista das Cidades com Maior Potencial para Detecção Precoce de Patógenos por UF',
          titulo_orig_dest: 'Cidades de Origem dos Avisos na APS e Municípios Destino Recomendados para Coleta Genômica',
          titulo_estados: 'Consulta dos Indicadores nos Municípios',
          col1: 'Município​',
          col2: 'População',
          col3: 'Taxa de Crescimento (Proporção Gripais) %',
          col9: 'EVI (Índice de Volatilidade Epidêmica)',
          col4: 'Excesso de Atendimentos (Gripais)',
          col5: 'Limite Superior Esperado de Atendimentos (Gripais)',
          col6: 'Proporção de Provável Sindrome Gripal',
          col7: 'Provável Sindrome Gripal',
          col8: 'Atendimentos Totais',
          media_movel_proporcao: 'Média Móvel Proporção',
          estado: 'UF',
          limite: 'Limite',
          limite_ambos: 'Limite EVI & EARS',
          excesso: 'Excesso',
          excesso_ambos: 'Excesso EVI & EARS',
          evi: 'EVI',
          ears: 'EARS',
          ens: 'Aviso APS',
          ml: 'ML',
          glm: 'GLM',
          sinal_evi: 'Aviso EVI Consecutivo',
          sinal_ears: 'Aviso EARS Consecutivo',
          sinal_ambos: 'Aviso EVI e Ears Consecutivo',
          sinal_ens: 'Aviso APS Consecutivo',
          sinal_ens_atual: 'Aviso AESOP',
          sinal_ml: 'Aviso ML Consecutivo',
          excesso_ml: 'Excesso ML',
          limite_ml: 'Limite ML',
          sinal_glm: 'Aviso GLM Consecutivo',
          limite_glm: 'Limite GLM',
          excesso_glm: 'Excesso GLM',
          sinais: 'Total de Avisos',
          classe_ibp: 'Classe IBP',
          semana_ep: 'Semana Epidemiológica',
          regiao_saude: 'Região de Saúde',
          alerta_aesop: 'Aviso AESOP',
          sinais_vizinhos: 'Sinais Vizinhos',
          sigla_semana_ep: 'SE'
        },
        todos: 'Todos',
        mensagemNaoFoiPossivelCalcularTaxaCrescimento: 'Não foi possível calcular taxa de crescimento',
        subMensagemNaoFoiPossivelCalcularTaxaCrescimento: 'Indef',
        mesAno: 'Mês/Ano: ',
        flowMapNomeLayerMob: 'Rotas de Mobilidade',
        semanal: 'Semanal',
        mensal: 'Mensal',
        excesso: 'Excesso de Provável Sindrome Gripal do Limite Esperado',
        excesso_simples: 'Excesso',
        gripe: 'Gripe',
        arbo: 'Arbo',
        legenda: 'LEGENDA',
        variaveisClima: {
          Bio01BR: "Temperatura Média Anual do Ar",
          Bio02BR: "Faixa Média de Temperatura Diurna do Ar",
          Bio03BR: "Isotermalidade",
          Bio04BR: "Sazonalidade da Temperatura",
          Bio05BR: "Média da Temperatura Máxima Diária do Ar do Mês Mais Quente",
          Bio06BR: "Temperatura Mínima Média Diária do Mês Mais Frio",
          Bio07BR: "Variação Anual da Temperatura do Ar",
          Bio08BR: "Temperaturas Médias Diárias do Ar do Trimestre Mais Chuvoso",
          Bio09BR: "Temperaturas Médias Diárias do Ar do Trimestre Mais Seco",
          Bio10BR: "Temperaturas Médias Diárias do Ar do Trimestre Mais Quente",
          Bio11BR: "Temperaturas Médias Diárias do Ar do Trimestre Mais Frio",
          Bio12BR: "Quantidade Anual de Precipitação",
          Bio13BR: "Quantidade de Precipitação do Mês Mais Chuvoso",
          Bio14BR: "Quantidade de Precipitação do Mês Mais Seco",
          Bio15BR: "Sazonalidade da Precipitação",
          Bio16BR: "Quantidade Mensal Média de Precipitação do Trimestre Mais Chuvoso",
          Bio17BR: "Quantidade Mensal Média de Precipitação do Trimestre Mais Seco",
          Bio18BR: "Quantidade Mensal Média de Precipitação do Trimestre Mais Quente",
          Bio19BR: "Quantidade Mensal Média de Precipitação do Trimestre Mais Frio",
        },
        variaveisGoogle: {
          coriza: "Coriza",
          covid: "Covid",
          diarreia: "Diarreia",
          dor_de_cabeca: "Dor de Cabeça",
          dor_de_garganta: "Dor de Garganta",
          falta_de_ar: "Falta de Ar",
          febre: "Febre",
          gripe: "Gripe",
          resfriado: "Resfriado",
          tosse: "Tosse",
          vomito: "Vômito",
          termos: "Termos",
        },
        variavel: "Variável",
      }
      ,
      help: {
        icon: 'Ajuda',
        title: 'Guia técnico dos elementos e informações nos painéis do AESOP',
        search: 'Filtrar tópicos',
        topic: 'Tópicos'
      }
    }
  }